export default "assets/images/texture-7e89e3b6.png";